import { menuConfig, menuFixo } from './menuConfig';

export default {
    data() {
        return {
            menuPrincipal: [],
            menuFixoProcessado: []
        };
    },

    methods: {
        filtrarPorPermissao(items) {
            return items.filter(item => {
                // Se não tem permissão definida, sempre exibe
                if (!item.permissao) {
                    return true;
                }
                // Verifica se tem a permissão necessária
                return this.permissao(item.permissao);
            });
        },

        processarItemMenu(item) {
            const itemProcessado = { ...item };

            // Se tem submenu, filtra os itens do submenu
            if (item.subMenuStatus && item.subMenu && item.subMenu.length > 0) {
                itemProcessado.subMenu = this.filtrarPorPermissao(item.subMenu);

                // Se após filtrar não sobrou nenhum submenu, não exibe o menu pai
                if (itemProcessado.subMenu.length === 0) {
                    return null;
                }
            }

            return itemProcessado;
        },

        carregarMenus() {
            // Filtra menus principais por permissão
            const menusFiltrados = this.filtrarPorPermissao(menuConfig);

            // Processa cada menu (filtra submenus)
            this.menuPrincipal = menusFiltrados
                .map(item => this.processarItemMenu(item))
                .filter(item => item !== null);

            // Processa menu fixo
            this.menuFixoProcessado = this.filtrarPorPermissao(menuFixo);

            return this.menuPrincipal;
        },
    },
};